import { connect } from 'react-redux';
import { navbarActionCreators } from './NavBarActions'
import NavBar from './NavBar'


const mapStateToProps = state => {
    const unSeenMessages = state.ui.navBar.unSeenMessages;
    const notifications = state.ui.navBar.notifList;
    const notifsCount = state.ui.navBar.notifsCount;
    const showNotifsList = state.ui.navBar.showNotifsList;
    return {
        unSeenMessages,
        notifications,
        notifsCount,
        showNotifsList
    }
};

const mapDispatchToProps = dispatch => ({
    initData: () => {
        dispatch(navbarActionCreators.getUserInfoFromApi())
        dispatch(navbarActionCreators.getNotificationsFromApi())
    },
    toggleNotifsList: (payload) => {
        dispatch(navbarActionCreators.toggleNotifsList(payload))
    },
    hideNotifsList: () => {
        dispatch(navbarActionCreators.hideNotifsList())
    }
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NavBar);
